import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ReturnsIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M10.98 4.53h-.76v-1.5l-3.5 2 3.5 2v-1.5h.76c1.79 0 3.25 1.46 3.25 3.25s-1.46 3.25-3.25 3.25H1.23v1h9.75a4.26 4.26 0 0 0 4.25-4.25 4.26 4.26 0 0 0-4.25-4.25Z" />
  </IconWrapper>
)

export default ReturnsIconSmall
